import React from 'react';
import CategoryExplorerView from './CategoryExplorerView';

export interface CategoryExplorerRouteProps {
  className?: string;
}

const CategoryExplorerRoute: React.FC<CategoryExplorerRouteProps> = ({ className = '' }) => {
  return (
    <div className={className}>
      <CategoryExplorerView />
    </div>
  );
};

export default CategoryExplorerRoute;
